import type { EspionageV2MapCamera, EspionageV2MapViewport } from './espionageV2WorldMapUtils'
import {
  espionageMapToScreenPoint,
  getEspionageVisibleMapBounds,
} from './espionageV2WorldMapUtils'

/** Grid spacing in map pixel space — scales visually when zooming. */
export const ESPIONAGE_V2_MAP_GRID_STEP = 40

/** Light vignette over map.webp — keeps panel frame readable. */
export function drawEspionageV2MapSurface(
  ctx: CanvasRenderingContext2D,
  viewport: EspionageV2MapViewport,
): void {
  const { width, height } = viewport

  const gradient = ctx.createLinearGradient(0, 0, 0, height)
  gradient.addColorStop(0, 'rgba(42, 32, 22, 0.14)')
  gradient.addColorStop(0.5, 'rgba(28, 20, 14, 0.1)')
  gradient.addColorStop(1, 'rgba(20, 14, 10, 0.16)')
  ctx.fillStyle = gradient
  ctx.fillRect(0, 0, width, height)
}

/** Grid lines in map space — pan and zoom with castles. */
export function drawEspionageV2MapGrid(
  ctx: CanvasRenderingContext2D,
  viewport: EspionageV2MapViewport,
  camera: EspionageV2MapCamera,
): void {
  const bounds = getEspionageVisibleMapBounds(viewport, camera, 96)
  const step = ESPIONAGE_V2_MAP_GRID_STEP
  const startX = Math.floor(bounds.minX / step) * step
  const startY = Math.floor(bounds.minY / step) * step

  ctx.save()
  ctx.strokeStyle = 'rgba(177, 131, 78, 0.5)'
  ctx.lineWidth = 1

  for (let mx = startX; mx <= bounds.maxX; mx += step) {
    const top = espionageMapToScreenPoint(mx, bounds.minY, viewport, camera)
    const bottom = espionageMapToScreenPoint(mx, bounds.maxY, viewport, camera)
    ctx.beginPath()
    ctx.moveTo(top.x, top.y)
    ctx.lineTo(bottom.x, bottom.y)
    ctx.stroke()
  }

  for (let my = startY; my <= bounds.maxY; my += step) {
    const left = espionageMapToScreenPoint(bounds.minX, my, viewport, camera)
    const right = espionageMapToScreenPoint(bounds.maxX, my, viewport, camera)
    ctx.beginPath()
    ctx.moveTo(left.x, left.y)
    ctx.lineTo(right.x, right.y)
    ctx.stroke()
  }

  ctx.restore()
}
